// dashboard-agent-ia/src/pages/ocass/utils/senegalGeo.js
// Découpage administratif du Sénégal (miroir backend) pour la cascade Région → Département

export const SENEGAL_GEO = {
  'Dakar': ['Dakar', 'Guédiawaye', 'Pikine', 'Rufisque', 'Keur Massar'],
  'Thiès': ['Thiès', 'Mbour', 'Tivaouane'],
  'Diourbel': ['Diourbel', 'Bambey', 'Mbacké'],
  'Fatick': ['Fatick', 'Foundiougne', 'Gossas'],
  'Kaolack': ['Kaolack', 'Guinguinéo', 'Nioro du Rip'],
  'Kaffrine': ['Kaffrine', 'Birkelane', 'Koungheul', 'Malem Hodar'],
  'Louga': ['Louga', 'Kébémer', 'Linguère'],
  'Saint-Louis': ['Saint-Louis', 'Dagana', 'Podor'],
  'Matam': ['Matam', 'Kanel', 'Ranérou'],
  'Tambacounda': ['Tambacounda', 'Bakel', 'Goudiry', 'Koumpentoum'],
  'Kédougou': ['Kédougou', 'Salémata', 'Saraya'],
  'Kolda': ['Kolda', 'Médina Yoro Foulah', 'Vélingara'],
  'Sédhiou': ['Sédhiou', 'Bounkiling', 'Goudomp'],
  'Ziguinchor': ['Ziguinchor', 'Bignona', 'Oussouye'],
}

export const REGIONS = Object.keys(SENEGAL_GEO)
export const getDepartments = (region) => SENEGAL_GEO[region] || []
